import { render, staticRenderFns } from "./newviewsdetails_mobile.vue?vue&type=template&id=6fb4ef3f&scoped=true&"
import script from "./newviewsdetails_mobile.vue?vue&type=script&lang=js&"
export * from "./newviewsdetails_mobile.vue?vue&type=script&lang=js&"
import style0 from "./newviewsdetails_mobile.vue?vue&type=style&index=0&id=6fb4ef3f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb4ef3f",
  null
  
)

export default component.exports